import firebase from 'firebase/app'
import 'firebase/database'
import { defaultUserSettings, defaultUserStatistic } from "../helpers/configs";
import {reportEvent} from "@/helpers/utils";


const firebaseConfig = {
    apiKey: "AIzaSyDVr4NFYNkJBnPwl-d1SIlP-Jtj0kvZsRU",
    authDomain: "browserlock-kids-mode.firebaseapp.com",
    databaseURL: "https://browserlock-kids-mode-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "browserlock-kids-mode",
    storageBucket: "browserlock-kids-mode.appspot.com",
    messagingSenderId: "919151156251",
    appId: "1:919151156251:web:c61c8b42db36f47ffc6cbe",
    measurementId: "G-5HDBDTYFQR"
}

firebase.initializeApp(firebaseConfig)
export const db = firebase.database()

localStorage.removeItem('isRemote');

firebase.auth().onAuthStateChanged((user) => {
    if (user) {
        console.log(user.uid, user.email);
        db.ref('users/' + user.uid).get().then((snapshot) => {
            if (snapshot.exists()) {
                const dateString = new Date().toDateString();
                const settings = snapshot.val().settings
                if (settings.resetDate !== dateString) {
                    snapshot.child('settings/');
                    const updates = {};
                    updates['/resetDate'] = dateString;
                    updates['/todayDailyLimit'] = settings.dailyLimit;
                    updates['/dailyLimitUsed'] = 0;
                    db.ref('users/' + user.uid + '/settings').update(updates);
                }

            } else {
                db.ref('users/' + user.uid).set({
                    settings: defaultUserSettings,
                    statistic: defaultUserStatistic
                });
            }
        }).catch((error) => {
            console.error(error);
        });
    } else {
        firebase.auth().signInAnonymously()
            .then((info) => {
                console.log(info.user.uid);
                reportEvent('userSignIn', {'userID': info.user.uid, 'isAnonymous': true})
            })
            .catch((error) => {
                var errorCode = error.code;
                var errorMessage = error.message;
                console.log(errorCode, errorMessage);
            });
    }
})


